import { useState, useEffect } from "react";

export const HomePopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const hasShown = sessionStorage.getItem("homePopupShown");
    if (!hasShown) {
      setIsOpen(true);
      sessionStorage.setItem("homePopupShown", "true");
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        setIsOpen(false);
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 p-4"
      onClick={() => setIsOpen(false)}
    >
      <div 
        className="relative bg-white rounded-lg shadow-2xl max-w-2xl max-h-[70vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={() => setIsOpen(false)}
          className="absolute -top-3 -right-3 text-black hover:text-gray-700 bg-white border border-gray-300 rounded-full w-8 h-8 flex items-center justify-center text-xl font-bold shadow-md cursor-pointer z-10 leading-none"
          aria-label="Close"
        >
          &times;
        </button>
        <img 
          src="/img/28-years-poster.jpg" 
          alt="28 Years Poster" 
          className="w-full h-auto max-h-[65vh] object-contain rounded-lg"
        />
      </div>
    </div>
  );
};
